const API_KEY = "fac3076f140827a5fdce2f3139e1e1e8"

const makeIconURL = (iconId) =>
    `https://openweathermap.org/img/wn/${iconId}@2x.png`;

const getFormattedWeatherData = async (city, units = "metric") => {
    const URL = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${API_KEY}&units=${units}`;

    const data = await fetch(URL)
        .then((res) => res.json())
        .then((data) => data);

    const {
        weather,
        main: { temp, feels_like, temp_min, temp_max, pressure, humidity },
        wind: { speed },
        sys: { country },
        name,
    } = data;

    const { description, icon } = weather[0];

    return {
        name,
        country,
        iconURL: makeIconURL(icon),
        temp,
        temp_min,
        temp_max,
        feels_like,
        speed,
        pressure,
        humidity,
        description,
    };
};

export { getFormattedWeatherData };